import { SharingLinkInfo, updateSharingLinkFromSharingDialog } from 'owa-link-data';
import { lazyOnLinkHasChanged } from 'owa-recipient-permission-checker';
import { ODBSharingInfo, SharingTipRecipientInfo } from 'owa-sharing-data';
import { lazyOpenSharingDialog, SharingDialogResponse } from 'owa-sharing-dialog';
import { closeLinkContextMenu } from '../components/LinkContextMenu';

export async function onOpenSharingDialogClicked(
    sharingLink: SharingLinkInfo,
    composeId: string,
    recipientInfos: SharingTipRecipientInfo[]
) {
    closeLinkContextMenu();
    const openSharingDialog = await lazyOpenSharingDialog.import();
    const sharingInfo: ODBSharingInfo = <ODBSharingInfo>sharingLink.sharingInfo;

    const canonicalUrl = sharingInfo.canonicalUrl;
    const endpointUrl = sharingInfo.siteUrl;
    openSharingDialog(endpointUrl, canonicalUrl, sharingInfo.shareId, sharingLink.permissionLevel)
        .then((response: SharingDialogResponse) => {
            const linkHasChanged = response.shareId !== sharingInfo.shareId;
            updateSharingLinkFromSharingDialog(sharingLink.linkId, response);

            if (linkHasChanged) {
                lazyOnLinkHasChanged.importAndExecute(
                    sharingLink.linkId,
                    response.permissionLevel,
                    recipientInfos,
                    composeId
                );
            }
        })
        .catch(() => {});
}
